<mat-toolbar class="footer" color="primary">
	<span>Copyright &copy; 2021 EAD Systeme</span>
	<div align="end" mat-dialog-actions>
		<!--<mat-label>Version {{version}}</mat-label>-->
	</div>
</mat-toolbar>
